import { conformArrayResponse, conformObjectResponse } from '~/api/utils';
import { axiosInstance } from '~/api/config/axios.config';
import { MusicDetailDto, MusicListItemDto, SongDealsSummaryDto, SongSummaryListDto } from '~/models/music/music.dto';
import { NewSongResponseDto } from '~/models/music/new-song/newSongResponse.dto';
import { NewDealResponseDto } from '~/models/deals/new-deal/NewDealResponse.dto';
import { SongListings } from '~/models/music/SongListings.dto';

export class MusicApi {
    static async getMusics(ProjectId: number) {
        return conformArrayResponse(axiosInstance.get('/catalogue/projectCreator/SongSummary', { params: { ProjectId } }), MusicListItemDto);
    }

    //SOng summary List
    static async getSongSummaryList(ProjectId: number, assetCode: string) {
        return conformArrayResponse(
            axiosInstance.get('/catalogue/projectCreator/deal/SongSummarylist', { params: { ProjectId, assetCode } }),
            SongSummaryListDto
        );
    }

    static async getSongDealsSummary(ProjectId: number, songref: number) {
        return conformArrayResponse(
            axiosInstance.get('/catalogue/projectCreator/song/DealSummaryList', { params: { ProjectId, songref } }),
            SongDealsSummaryDto
        );
    }

    static async exportMusics(filters: {projectId: number, searchText?: string, releasedatefrom?: string, releasedateto?: string}) {
        return axiosInstance.get('/catalogue/projectCreator/SongSummary', {
            params: { ...filters, export: true },
            responseType: 'blob',
        });
    }

    static async getMusicDetail(assetCode: string) {
        return conformObjectResponse(axiosInstance.get('/catalogue/projectCreator/SongDetail', { params: { assetCode } }), MusicDetailDto);
    }

    // static async linkDeal(id: any, projectId: number, assetCode: string ) {
    //     return axiosInstance.post('/catalogue/projectCreator/asset/link', { params: {  projectid:projectId, assetcode:id, songref:  assetCode} });
    // }

    // static async unlinkDeal(id: any, projectId: number, assetCode: string ) {
    //     return axiosInstance.post('/catalogue/projectCreator/asset/unlink', { params: {  projectid:projectId, assetcode:assetCode, songref:id } });
    // }

    static async exportMusicDetails(assetCode: string) {
        return axiosInstance.get('/catalogue/projectCreator/SongDetail', {
            params: { assetCode, export: true },
            responseType: 'blob',
        });
    }

    static async createNewSong(data: any) {
        return axiosInstance.put<NewSongResponseDto>('/catalogue/projectCreator/songentrycreate', data);
    }

    static async songUpdateStatus(songRef: string, status: number) {
        return axiosInstance.put<NewDealResponseDto>('/catalogue/projectCreator/songupdatestatus', { songRef, status });
    }

    static async SongAssets(songRef: string, status: number) {
        return axiosInstance.put<NewDealResponseDto>('/catalogue/projectCreator/songupdatestatus', { songRef, status });
    }

    static async linkDeal(songRef: string, projectId: number, dealAssetCode: string) {
        return axiosInstance.post(`/catalogue/projectCreator/asset/link?projectId=${projectId}&assetCode=${dealAssetCode}&songRef=${songRef}`);
    }

    // catalogue/projectCreator/asset/link?projectid=22&SongRef=GAIKO20-0001153&assetcode=P22AN09

    static async unlinkDeal(songRef: string, projectId: number, dealAssetCode: string) {
        return axiosInstance.post(`/catalogue/projectCreator/asset/unlink?projectId=${projectId}&assetCode=${dealAssetCode}&songRef=${songRef}`);
    }

    static async getSongTag(songRef: string, projectId: number) {
        return axiosInstance.get(`/catalogue/projectcreator/isrcSongTagLinklist?gsongRef=${songRef}&projectId=${projectId}`);
    }

    static async getSongListingList(title: string) {
        return conformArrayResponse(axiosInstance.get(`/catalogue/projectCreator/userlisting/list?listingkey=SONG${title}&listingarea=PUBLISHING`), SongListings);
    }
    static async getTagListingList(title: string) {
        return conformArrayResponse(axiosInstance.get(`/catalogue/projectCreator/userlisting/list?listingkey=${title}TAG&listingarea=PUBLISHING`), SongListings);
    }
}
